import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { NSpace, NLayout, NLayoutSider, NMenu } from 'naive-ui';

import { currentRouteName, navOptions } from '@/helpers/navigation';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const activeKey = currentRouteName(route);
const collapsed = ref(true);
const triggerStyle = { top: '55px' };

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(NSpace), { vertical: "" }, {
    default: _withCtx(() => [
      _createVNode(_unref(NLayout), { "has-sider": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NLayoutSider), {
            class: "side-menu__layout-sider",
            bordered: "",
            "collapse-mode": "width",
            "collapsed-width": 64,
            width: 180,
            collapsed: collapsed.value,
            "show-trigger": "",
            "trigger-style": triggerStyle,
            "collapsed-trigger-style": triggerStyle,
            onCollapse: _cache[0] || (_cache[0] = ($event: any) => (collapsed.value = true)),
            onExpand: _cache[1] || (_cache[1] = ($event: any) => (collapsed.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NMenu), {
                value: _unref(activeKey),
                collapsed: collapsed.value,
                "collapsed-width": 64,
                "collapsed-icon-size": 22,
                options: _unref(navOptions)
              }, null, 8, ["value", "collapsed", "options"])
            ]),
            _: 1
          }, 8, ["collapsed"]),
          _createVNode(_unref(NLayout), { id: "main" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})